import { html, ifDefined } from "../../../"
import {
  getDateISOString,
  getDateValue,
  getOnlyDateISOString,
  isFirefox,
  isIOS,
  isMobile,
  isSafari,
} from "../../../global/globals"
import { SnackAdd } from "../../snackapi"

import { _setFieldFocus } from "../helper"
import { _focusOutHelper } from "./helpers"
import { SYSControlBase } from "./syscontrolbase"

export class SYSDate extends SYSControlBase {
  inputPickerElement: any
  async init() {
    if (!isIOS()) {
      this.addEventListener("change", (e) => this.handleChange(e))
    }

    // if (isMobile() && !isIOS()) {
    //   this.addEventListener("input", (e) => this.handleInput(e))
    // }
    // if (!(isMobile() && !isIOS())) {
    //this.addEventListener("change", (e) => this.handleChange(e))
    //}
    await super.init()
  }

  // for mobile the picker always delivers: yyyy-mm-dd in the e.target.value
  //

  setInputElementValueFromDatePicker(pickerVal: string) {
    let value = pickerVal
    if (pickerVal) {
      let dvals = pickerVal.split("-")
      let dval = new Date(
        parseInt(dvals[0]),
        parseInt(dvals[1]) - 1,
        parseInt(dvals[2])
      )
      let onlyDateIsoString = getOnlyDateISOString(dval)
      let value = getDateValue(onlyDateIsoString)
    }
    let isInnerEvent = false
    this.actions.ovl.form._ChangeField({
      fieldKey: this.field.fieldKey,
      formState: this.formState,
      value,
      isInnerEvent,
      watched: true,
      noRetrigger: true,
    })
  }

  // handleInput(e: Event) {
  //   e.stopPropagation()
  //   e.preventDefault()
  //   //@ts-ignore
  //   let pickerVal = e.target.value
  //   SnackAdd("handleInput")
  //   this.setInputElementValueFromDatePicker(pickerVal)
  // }
  handleChange(e: Event) {
    e.stopPropagation()
    e.preventDefault()
    let isInnerEvent = true

    //@ts-ignore
    if (e.target.id == "picker" + this.field.id) {
      //@ts-ignore
      let pickerVal = e.target.value
      //@ts-ignore
      if (!pickerVal || pickerVal.length < 10) {
        this.inputElement.value = ""
      } else {
        let dval = new Date(pickerVal)
        this.inputElement.value = getDateValue(getDateISOString(dval))
      }
      // workaround to remove focus after picker select
      // that ensures validationhint display after selecting directly
      // its all about validationhintdisplay
      this.field.hasFocus = false
    }

    isInnerEvent = false

    this.actions.ovl.form._ChangeField({
      fieldKey: this.field.fieldKey,
      formState: this.formState,
      value: this.inputElement.value,
      isInnerEvent,
      watched: true,
      noRetrigger: true,
    })
    //@ts-ignore
    if (e.target.id === this.field.id) {
      this.updatePickerElement()
    }
  }

  handleFocus() {
    _setFieldFocus(this.field, true)
  }

  handleFocusOut(e) {
    if (!(e.relatedTarget && e.relatedTarget.id === "picker" + this.field.id)) {
      _focusOutHelper(e, this.field)
    }
  }
  handleBlur(e) {
    if (isIOS()) {
      this.handleChange(e)
    }
  }

  ignorePickerTextField(e: KeyboardEvent) {
    if (!isMobile()) {
      this.inputElement.focus()
    }
  }

  // keyUp(e: KeyboardEvent) {
  //   // 24.01.24 was causing that quickly entered values were swallowed
  //   // -> uncommented
  //   // // workaround to set focus after it was to false in picker select
  //   // // its all about validationhintdisplay
  //   // _setFieldFocus(this.field, true)
  //   // this.actions.ovl.form._ChangeField({
  //   //   fieldKey: this.field.fieldKey,
  //   //   formState: this.formState,
  //   //   value: this.inputElement.value,
  //   //   isInnerEvent: true,
  //   //   watched: true,
  //   // })
  // }

  updatePickerElement() {
    if (this.inputPickerElement) {
      if (this.field.convertedValue) {
        let dval = new Date(this.field.convertedValue)
        if (!isNaN(dval.getDate())) {
          this.inputPickerElement.value = getDateISOString(dval).replace(
            "T00:00:00",
            ""
          )
        } else {
          this.inputPickerElement.value = ""
        }
      } else {
        this.inputPickerElement.value = ""
      }
    }
  }
  async getUI() {
    let visible = super.InitControl()
    if (visible === false) {
      return undefined
    }
    let field = this.field
    let readonly = this.getReadOnly()
    let type: "date" | "text" = "text"
    let browserDatePicker
    let browserDatePickerButton
    let browserDatePickerClass = "ovl-input-date"
    if (isMobile()) {
      type = "date"
    } else if (field.ui.useBrowserDatePicker && !isSafari() && !readonly) {
      browserDatePickerClass = "ovl-input-datepickertarget"
      browserDatePicker = html`
        <input
          tabindex="-1"
          type="date"
          class="${this.getEditorClass()} fd-input ovl-input-datepicker ${field
            .ui.readonly
            ? "ovl-disabled"
            : ""}"
          @keydown=${(e) => this.ignorePickerTextField(e)}
          @click=${(e) => this.ignorePickerTextField(e)}
          id="picker${field.id}"
          ?readonly=${readonly}
          ?required=${isFirefox()}
          value="${field.convertedValue
            ? field.convertedValue.replace("T00:00:00", "")
            : ""}"
        />
      `
      // if (isFirefox()) {
      //   browserDatePickerButton = html` <span
      //     class="${this.getEditorClass()} sap-icon sap-icon--calendar ovl-input-datepickerffbutton ${field
      //       .ui.readonly
      //       ? "ovl-disabled"
      //       : ""}"
      //   ></span>`
      // }
    }
    //this.displayValue = getDateValue(field.convertedValue, field.ui.format)
    let fieldValue = field.value

    if (type === "date") {
      if (!fieldValue) {
        fieldValue = ""
      }
      if (field.convertedValue) {
        let dval = new Date(field.convertedValue)
        fieldValue = getDateISOString(dval).replace("T00:00:00", "")
      }
    }

    return html`
      <div
        class="${this.getContainerClass(
          "date",

          this.customInfo.customRowClassContainerName
        )}"
      >
        <ovl-controllabel .props=${() => this.field}> </ovl-controllabel>
        <div
          class="ovl-formcontrol-value ovl-inputcontainer-datebox  fd-input-group  __inpfocbox ${this.getOutlineValidationHint()}"
        >
          <input
            tabindex=${ifDefined(!this.focusable ? "-1" : undefined)}
            @focus=${() => this.handleFocus()}
            @focusout=${(e) => this.handleFocusOut(e)}
            @blur=${(e) => this.handleBlur(e)}
            autocomplete="${field.ui.autocomplete}"
            name="${field.ui.autocomplete !== "off"
              ? field.ui.autocomplete
              : this.field.fieldKey}"
            class="fd-input ${browserDatePickerClass} ${this.getInputClass(
              "date",

              this.customInfo.customRowClassName,
              true
            )}"
            type="${type}"
            id="${field.id}"
            value="${fieldValue}"
            spellcheck="false"
            ?readonly="${readonly}"
          />

          ${browserDatePicker} ${browserDatePickerButton}
        </div>
        <div id="focusafter${field.id}" tabindex="-1"></div>
        <ovl-controlcustomhint .props=${() => this.field}>
        </ovl-controlcustomhint>
        <ovl-controlvalidationhint .props=${() => this.field}>
        </ovl-controlvalidationhint>
      </div>
    `
  }
  async afterRender() {
    // // place picker under date with picker on the right just visible
    this.inputElement = document.getElementById(this.field.id)
    if (
      this.inputElement &&
      (this.inputElement.type !== "date" || isMobile())
    ) {
      if (this.field.convertedValue) {
        if (isMobile()) {
          this.inputElement.defaultValue = ""
          this.inputElement.value = getDateISOString(
            new Date(this.field.convertedValue)
          ).replace("T00:00:00", "")
        } else {
          this.inputElement.value = this.field.value
          // if (!this.field.value) {
          this.updatePickerElement()
          //          }
        }
        // 20250505, added else if because setting value to null had no effect in the datecontrol ui
        // usecase oru. selected planned date -> error when conatcting api -> reset planned date to null so it can be selected again
      } else if (!this.field.value) {
        this.inputElement.value = ""
      }
    }
    if (this.inputPickerElement === undefined) {
      this.inputPickerElement = document.getElementById(
        "picker" + this.field.id
      )
      this.updatePickerElement()
    }
    await super.afterRender()
  }
  async disconnectedCallback() {
    if (!isIOS()) {
      this.removeEventListener("change", (e) => this.handleChange(e))
    }

    //   // if (isMobile()) {
    //   //   this.removeEventListener("input", (e) => this.handleInput(e))
    //   // } else {
    //   this.removeEventListener("change", (e) => this.handleChange(e))
    //   //}
    // }
    await super.disconnectedCallback()
  }
}
